import { useCallback } from "react";

import { type LensSubmissionType, type MylensesSubmissionDetailsSource } from "@snapchat/blizzard-schema";

import { type AdjustEventData, type UpdateEventData } from "../../analytics/event-creators";
import { useBlizzardEvents } from "../../analytics/hooks";

export const useLensDetailsBlizzardEvents = (
    isUpdatingExistsLens: boolean,
    lensSubmissionType: LensSubmissionType,
): { createChangeDetailsEvent: (source: MylensesSubmissionDetailsSource) => () => void } => {
    const { sendBlizzardEvent } = useBlizzardEvents();

    const createChangeDetailsEvent = useCallback(
        (source: MylensesSubmissionDetailsSource) => () => {
            const eventBody: AdjustEventData | UpdateEventData = {
                event: isUpdatingExistsLens ? "LENSSTUDIO_MYLENSES_UPDATE" : "LENSSTUDIO_MYLENSES_ADJUST",
                source,
                lensSubmissionType,
            };

            sendBlizzardEvent(eventBody);
        },
        [lensSubmissionType, isUpdatingExistsLens, sendBlizzardEvent],
    );

    return { createChangeDetailsEvent };
};
